import React from 'react';
import { Button } from '../../../components/ui/button';
import { RefreshCw, Loader2 } from 'lucide-react';

export const PipelineHeader = ({ PipelineIcon, formatCurrency, formatDate, handleSync, lastSync, pipelineName, stats, syncing }) => (
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="p-1.5 sm:p-2 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex-shrink-0">
            <PipelineIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
          </div>
          <div className="min-w-0">
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 dark:text-white truncate">
              {pipelineName}
            </h1>
            <p className="text-xs sm:text-sm text-gray-500 truncate">
              {stats.total} patients • {formatCurrency(stats.value)} total value
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2 flex-shrink-0">
          {lastSync && (
            <span className="text-xs text-gray-500 hidden sm:inline">
              Last sync: {formatDate(lastSync)}
            </span>
          )}
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleSync}
            disabled={syncing}
            data-testid="sync-pipeline-button"
          >
            {syncing ? (
              <Loader2 className="w-4 h-4 mr-1 sm:mr-2 animate-spin" />
            ) : (
              <RefreshCw className="w-4 h-4 mr-1 sm:mr-2" />
            )}
            <span className="hidden xs:inline">Sync</span>
            <span className="xs:hidden">↻</span>
          </Button>
        </div>
      </div>
);
